import { render, staticRenderFns } from "./PazienteConsensiList.vue?vue&type=template&id=f6f0bf34&scoped=true"
import script from "./PazienteConsensiList.vue?vue&type=script&lang=js"
export * from "./PazienteConsensiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f0bf34",
  null
  
)

export default component.exports